module.exports = __webpack_public_path__ + "img/menu.cc92ff95.svg";